/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "core-js/stable"
import "regenerator-runtime/runtime"
// import "./hello_react"
console.log("Hello Again from Webpacker")
// The antd style import didnt work, so linking from cdn directly from layout/application.html
import "antd/dist/antd.css"
import WebpackerReact from "webpacker-react"

window.WebpackerReact = WebpackerReact
// import 'react-sortable-tree/style.css';

import ProfileMain from "../employees/components/profile_main"
// import SearchAutoComplete from "../autocomplete/search"

// WebpackerReact.setup({ SearchAutoComplete, ProfileMain })

import DateRangeSelector from "../common/date_range_selector"
import DateRangeSelectorExtended from "../common/date_range_selector_extended"
import UserRemoteSelect from "../common/user_remote_select"
import StockReport from "../stock/stock_report"
import StockReportMenu from "../stock/report_menu"
// import OpeningStock from '../stock/opening_stock'
import OpeningStockItem from "../stock/opening_stock_item"
import StockTransfer from "../stock/stock_transfer"
import BackOrderedReport from "../stock/backordered"
import TrialBalance from "../accounts/trial_balance"
import ChartOfAccount from "../accounts/chart_of_account"
import OpeningBalance from "../accounts/opening_balance"
import ProductList from "../products/ProductList"
import POSDisplay from "../products/POSDisplay"
// Autocomplete
import SearchAutoComplete from "../autocomplete/search"
// import ReactSelect from '../common/react_select'
import ReactSelectProduct from "../common/react_select_product"
import ProductionTransaction from "../reactjs/containers/production_transaction"

import StockHistory from "../stock/stock_history"
import StockTransferDetails from "../stock/stock_transfer_details"
import StockMovements from "../stock/movements"

// window.HTMLUtil = HTMLUtil;

//First uncomment module.exports = Tafgeet; in "../common/tafgeet"
// import Tafgeet from "../common/tafgeet";
// window.Tafgeet = Tafgeet;

WebpackerReact.setup({
  ProfileMain,
  TrialBalance,
  ChartOfAccount,
  OpeningBalance,
})
WebpackerReact.setup({ DateRangeSelector, DateRangeSelectorExtended })
WebpackerReact.setup({ ReactSelectProduct })
WebpackerReact.setup({ ProductionTransaction })
WebpackerReact.setup({ UserRemoteSelect, StockTransferDetails, StockMovements })
WebpackerReact.setup({
  StockReport,
  OpeningStockItem,
  StockTransfer,
  BackOrderedReport,
  StockReportMenu,
  StockHistory,
})
WebpackerReact.setup({ SearchAutoComplete, ProductList, POSDisplay })
// */
import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import t from "../i18n/ar.json"
// console.log("ar", ar)

const application = Application.start()
const context = require.context("../stimulus/controllers", true, /\.js$/)
application.load(definitionsFromContext(context))
